import {httpGet, httpPut, httpDelete, httpPost, httpPostForm} from '../../../util/request.js';
import appConfig from '../../../config';

export default class OrderDetailApi {

    static QUERY_CHECK_ORDER_LIST = appConfig.gatewayUrl + appConfig.pdServicePath + "/wb/manage/order/list";
    static QUERY_CHECK_ORDER_DETAIL = appConfig.gatewayUrl + appConfig.pdServicePath + "/wb/manage/order/detail";

    static IMG_UPLOAD_URL = appConfig.gatewayUrl + appConfig.pdServicePath + "/common/file/upload";

    static listWbOrder(params) {
        return httpPost(OrderDetailApi.QUERY_CHECK_ORDER_LIST, params);
    }

    static detailWbOrder(params) {
        return httpGet(OrderDetailApi.QUERY_CHECK_ORDER_DETAIL, params);
    }

    static handleResponse(response, scope, successFunc, errorFunc) {
        let data = response.data;
        if (data.code == 200) {
            if (successFunc && typeof successFunc == 'function') {
                successFunc(data.data);
            }
        } else {
            let text = data.errMsg
            scope.$dialog.error({
                text: text,
                title: "错误"
            });
            if (errorFunc && typeof errorFunc == 'function') {
                errorFunc(data);
            }
        }
    }

    static handleNetworkError(response, scope, errorFunc) {
        scope.$dialog.error({
            text: response.message,
            title: "错误"
        });
        if (errorFunc && typeof errorFunc == 'function') {
            errorFunc(response);
        }
    }


}